import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { Environment } from '@cobliteam/react-environments';
import { getToastTypes } from '../registry';

// Um slot por tipo de toast: só monta o controller (hook) do tipo, que assina o realtime do feed
// compartilhado e dispara o toast. Não renderiza nada.
const NotificationToastSlot = ({ useController }: { useController: () => void }) => {
  useController();
  return null;
};

/**
 * Surface genérica do toast: monta um slot por tipo registrado com `surfaces.toast`. Mesmo master gate do
 * card flutuante (o KnockFeedProvider compartilhado precisa existir para `useKnockFeed`).
 */
const NotificationToast = () => {
  const { knockInApp } = useFeatureFlags();
  const { getSession } = useUser();
  const userId = getSession()?.user?.id;
  const { knockAPIKey, knockFeedChannelId } = Environment.getInstance().getEnvironment();

  if (!(knockInApp && knockAPIKey && knockFeedChannelId && userId)) return null;

  return (
    <>
      {getToastTypes().map((type) => (
        <NotificationToastSlot key={type.key} useController={type.useToastController!} />
      ))}
    </>
  );
};

export default NotificationToast;
